import clsx from 'clsx';
import { Link, Outlet, useLocation } from 'react-router-dom';

import { Icon } from '@/ui';

import { SETTINGS_PAGES, settingsLabel } from '../copy';

import type { SettingsPageId } from '../copy';

import { useLayoutOutletContext } from '@/components/Layouts/outletContext';

const navItemClass =
  'flex items-center gap-2.5 whitespace-nowrap rounded-[10px] border-0 bg-transparent px-3 py-2 text-left text-[15px] text-cement-400 no-underline hover:bg-sunny-200 hover:text-cement-500';

const activePage = (pathname: string): SettingsPageId => {
  const segment = pathname.split('/')[3] as SettingsPageId | undefined;
  return SETTINGS_PAGES.some((page) => page.id === segment) && segment
    ? segment
    : 'coaching-notes';
};

const SettingsShell = () => {
  const { pathname } = useLocation();
  const layout = useLayoutOutletContext();
  const active = activePage(pathname);

  return (
    <div className="mx-auto w-full max-w-[1060px] px-4 pb-28 pt-6 md:px-8">
      <header
        className="mb-6 flex items-center gap-2 text-sm"
        data-testid="settings-crumb"
      >
        <Link
          className="text-cement-400 no-underline"
          to="/m/settings/coaching-notes"
        >
          Settings
        </Link>
        <span aria-hidden="true" className="text-cement-300">
          /
        </span>
        <b className="text-cement-500">{settingsLabel(active)}</b>
      </header>
      <div className="grid gap-10 md:grid-cols-[268px_minmax(0,1fr)]">
        <nav
          aria-label="Settings"
          className="flex flex-col gap-0.5 md:sticky md:top-24 md:self-start"
        >
          <button
            className={navItemClass}
            disabled={!layout}
            type="button"
            onClick={layout?.openAccountSettings}
          >
            <Icon>person</Icon> Profile
          </button>
          {SETTINGS_PAGES.map((page) => (
            <Link
              key={page.id}
              aria-current={active === page.id ? 'page' : undefined}
              className={clsx(navItemClass, {
                'bg-white font-semibold text-cement-500 shadow-sm':
                  active === page.id,
              })}
              to={`/m/settings/${page.id}`}
            >
              <Icon>{page.icon}</Icon> {page.label}
            </Link>
          ))}
          <button
            className={navItemClass}
            disabled={!layout}
            type="button"
            onClick={layout?.openAccountSettings}
          >
            <Icon>notifications</Icon> Notifications
          </button>
        </nav>
        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SettingsShell;
